import * as React from "react";

import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { Menu } from "@v1/components/designSystem/menu/Menu";
import useSetDraftElement from "@v1/hooks/useSetDraftElement";
import { selectModalComponentData } from "@v1/reducers/tree-reducer";
import { useEditorSelector } from "@v1/store/store";
import ModalIcon from "@v1/svg/componenticon-modal";

export const TreeModalSelector = () => {
  const setDraftElement = useSetDraftElement();
  const modals = useEditorSelector(selectModalComponentData);

  if (modals.length === 0) {
    return null;
  }

  if (modals.length === 1) {
    return (
      <DeprecatedIconButton
        tooltipText="Jump to Popup Component"
        variant="tertiary"
        layoutClassName="h-6 w-6"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          setDraftElement({
            componentIds: [modals[0]!.id],
          });
        }}
        data-testid="tree-modal-selector"
        icon={<ModalIcon className="text-primary" />}
      />
    );
  }

  const options = modals.map((modal) => {
    return {
      id: modal.id,
      type: "leaf" as const,
      value: modal.id,
      title: modal.name,
      variant: "default" as const,
      size: "sm" as const,
      onSelect: () => {
        return setDraftElement({
          componentIds: [modal.id],
        });
      },
    };
  });

  return (
    <Tooltip content="Jump to Popup Components" triggerAsChild>
      <div>
        <Menu
          items={options}
          menuType="normal"
          customWidth={150}
          trigger={
            <DeprecatedIconButton
              variant="tertiary"
              layoutClassName="h-6 w-6"
              size="sm"
              icon={<ModalIcon className="text-primary" />}
            />
          }
        />
      </div>
    </Tooltip>
  );
};
